import Papa from 'papaparse';

export const parseCsvData = (csvData: string) => {
  const parsed = Papa.parse(csvData, {
    header: true,
    skipEmptyLines: true,
  });
  return parsed.data;
}; 